const listeners = new Map();

export const authEvents = {
  on(event, fn) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(fn);
    return () => listeners.get(event)?.delete(fn);
  },
  emit(event, payload) {
    listeners.get(event)?.forEach((fn) => {
      try {
        fn(payload);
      } catch {
        // listener error — swallow so one bad listener doesn't break the chain
      }
    });
  },
};
